module.exports = vendor_vue_7c5a4b90792d3eef7675;


//////////////////
// WEBPACK FOOTER
// external "vendor_vue_7c5a4b90792d3eef7675"
// module id = sqx2
// module chunks = 15